/**
 * Μαζεύει όλα τα stores και τα βάζει μέσα στο RootStore
 */
import { create } from 'mobx-persist';

import { AppStore } from './app-store';

export class RootStore {
  appStore = new AppStore();

  constructor() {
    const hydrate = create({ storage: localStorage });
    hydrate('WasteMgmt-CpApp-AppStore', this.appStore).then(() => {
      this.appStore.initialize();
    });
  }
}
